import styled from 'styled-components';

export const StyledUserPanelSubjects = styled.div`
    width: 100%;
    height: 100%;
`;
